import React from 'react';
import CustomTable, { IColumn } from './CustomTable';
import { Input, Typography } from '@mui/joy';
import { IMappedRate } from '../interface/IRate';

type Props = {
  rates: Partial<IMappedRate>[];
  onEdit: (date: string, key: keyof IMappedRate, value: string) => void;
  edit: boolean;
};

const RateTable = ({ rates, onEdit, edit }: Props) => {
  const columns: IColumn<IMappedRate>[] = [
    {
      id: 'date',
      disablePadding: false,
      label: 'Date',
      numeric: false,
      dataIndex: 'date',
      width: 150,
    },
    {
      id: 'dev',
      disablePadding: false,
      label: 'DEV',
      numeric: false,
      dataIndex: 'DEV',
      width: 150,
      render: (row) =>
        edit ? (
          <Input type='number' value={row.DEV} size='sm' onChange={(e) => onEdit(row.date, 'DEV', e.target.value)} />
        ) : (
          <Typography>{row.DEV}</Typography>
        ),
    },
    {
      id: 'pm',
      disablePadding: false,
      label: 'PM',
      numeric: true,
      dataIndex: 'PM',
      width: 150,
      render: (row) =>
        edit ? (
          <Input type='number' value={row.PM} size='sm' onChange={(e) => onEdit(row.date, 'PM', e.target.value)} />
        ) : (
          <Typography>{row.PM}</Typography>
        ),
    },
  ];

  return (
    <React.Fragment>
      <CustomTable data={rates} idKey='date' columns={columns} pagination={false} perPage={12} />
    </React.Fragment>
  );
};

export default RateTable;
